import React, {useCallback, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {ProductService} from "../product.service";
import {changePageTitle, setAlert} from "../../typescript/redux/actions";
import {IntegrationProduct} from "./integration-product-dlq";
import Datatable from "../../typescript/datatable/datatable";
import {ColorIconEnum} from "../../typescript/util/color-icon-enum";
import {Delete as DeleteIcon, Edit} from "@mui/icons-material";
import {ColorButtonEnum} from "../../typescript/util/color-button-enum";

const IntegrationProductDlqList = React.memo(() => {

    let navigate = useNavigate();
    const dispatch = useDispatch();

    const [items, setItems] = useState<IntegrationProduct[]>([]);

    const findAll = useCallback(async () => {
        const items = await ProductService.findAllErrorsInDlq();
        setItems(items);
    }, []);

    useEffect(() => {
        dispatch(changePageTitle("Produtos com erro na integração"));
        findAll().then();
    }, [dispatch, findAll]);

    const editItem = async (item: IntegrationProduct) => {
        if (item.errorMessage?.includes("não possui imagens")) {
            navigate(`/product/${item.productId}/images`);
        } else {
            navigate(`/product/${item.productId}`);
        }
    }

    const deleteItem = (item: IntegrationProduct) => {
        if (item.id === undefined) {
            return;
        }
        ProductService.deleteErrorInIntegrationDlq(item.id).then(() => {
            findAll().then();
        }).catch((error) => {
            dispatch(setAlert({
                show: true,
                message: 'Erro ao excluir registro - ' + error.message,
                severity: 'error'
            }));
        })
    }

    const rowOperations = [
        {color: () => ColorIconEnum.PRIMARY, onClick: deleteItem, label: () => 'Excluir', icon: () => <DeleteIcon/>},
        {color: () => ColorIconEnum.PRIMARY, onClick: editItem, label: () => 'Editar', icon: () => <Edit/>},
    ]

    const goBack = () => {
        navigate('/products');
    }

    const headerOperations = [
        {color: () => ColorButtonEnum.PRIMARY, onClick: goBack, label: () => 'Voltar'},
    ]

    return (
        <Datatable dataColumnNames={['ID do produto', 'Erro gerado', 'Data']} dataColumns={['productId', 'errorMessage', 'createdDate']}
                   dataTypes={['number', 'text', 'zonedatetime']} findAll={findAll} data={items} totalData={items.length}
                   rowOperations={rowOperations} headerOperations={headerOperations}/>
    )

});

export default IntegrationProductDlqList;